import React from "react";
import {DATA_HEADER} from "./data_header";
import CustomTable from "../../../components/tables/general-table/components/tables/CustomTable";
import {useDispatch, useSelector} from "react-redux";
import {
    selectedVariant,
    setSelectedTableRows
} from "../../dashboard/components/genomics-dashboard/components/results/components/variant-table/actions";

function Pharmacogenomics_Table(props){

   const dispatch = useDispatch();
    const {allDataApis } = useSelector((state) => state.generaltable);
    const selectedDir = allDataApis?.dir?.find(d => d.dir_id === allDataApis?.dirs?.dir_id);

  /* const handleSelectedPharmacogenomics= (variant) => {



      dispatch(selectedVariant(
          [{
              variant : variant,
              type: "Pharmacogenomics_Germline"
          }]))
    }*/


    const handleSelectedPharmacogenomics= (selectedRows) => {

        let data = {
            data_row : [selectedRows],
            data_type: "Pharmacogenomics_Germline",

        };

        dispatch(setSelectedTableRows(data))

    }



    return <CustomTable
        url={props.url}
        method= "POST"
        dataSend = {{
            "fields": [],
            "filtered": [
              {
                "id": "ExperimentID",
                "value": [selectedDir?.control_experiment_id]
              }
            ],
            "page": 1,
            "pageSize": 1000,
            "sorted": []
          }}  
        token={props.token}
        participant={props.participant}
        enableTag={props.enableTag}
        locationData="items"
        classRow= "Pharmacogenomics"
        dataType = {"Pharmacogenomics_Germline"}
        setSelected = {(pharmacogenomics) => handleSelectedPharmacogenomics(pharmacogenomics)}
        customFeatures= {[
            { SwitchFS: false },  
            { toggle: false },
            { expanding: false },
            { showHeader: false },
        ]}
        dataHeader={DATA_HEADER}
    />


}

export default Pharmacogenomics_Table
